module.exports = __webpack_public_path__ + "img/13-traffic-pattern-fr.b666daa5.jpg";